var _defs, _polygon, _g, _g2, _g3, _g4, _g5, _g6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgThinqEn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 150 47.96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clippath);}.cls-3{fill:#c00c3f;}.cls-4{fill:#6d6e71;}.cls-5{clip-path:url(#clippath-1);}.cls-6{clip-path:url(#clippath-4);}.cls-7{clip-path:url(#clippath-3);}.cls-8{clip-path:url(#clippath-2);}.cls-9{clip-path:url(#clippath-5);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 19.4,
    y: 8.64,
    width: 111.2,
    height: 29.75
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 19.4,
    y: 8.64,
    width: 111.2,
    height: 29.75
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 19.4,
    y: 8.64,
    width: 111.2,
    height: 29.75
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 19.4,
    y: 8.64,
    width: 111.2,
    height: 29.75
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 19.4,
    y: 8.64,
    width: 111.2,
    height: 29.75
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-5"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 19.4,
    y: 8.64,
    width: 111.2,
    height: 29.75
  })))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "19.4 9.38 19.4 13.38 28.36 13.38 28.36 38.4 33.31 38.4 33.31 13.38 42.23 13.38 42.23 9.38 19.4 9.38"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m86.21,18.13c-1.23,0-2.41.18-3.55.54-.3.09-.54.18-.78.28-.06.02-.1.04-.14.06l-.1.05c-.17.07-.34.14-.49.22-.1.05-.2.1-.3.15l-.2.11c-.06.04-.12.06-.18.09-.17.11-.33.21-.49.33l-.08.04c-.24.17-.42.31-.59.46-.63.52-1.12,1.1-1.47,1.72-.18.35-.62,1.43-.62,3.52v12.71h4.88v-12.36c0-.28.05-.5.09-.71.01-.1.04-.21.08-.33.65-1.99,2.88-2.63,3.61-2.69h.12c.06-.02.12-.02.19-.02l.42.03c1.31.17,3.7,1.24,3.7,3.71v12.36h4.88v-12.71c0-2.33-.6-3.48-.71-3.69-1.44-2.3-4.77-3.86-8.27-3.87"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m53.87,18.13c-1.16,0-2.31.17-3.4.5l-.71.21v-9.46h-4.88v29.02h4.9v-12.51c.02-.22.04-.4.07-.56.02-.1.04-.21.08-.33.65-1.99,2.88-2.63,3.61-2.69h.12c.06-.02.13-.02.19-.02l.42.03c1.3.17,3.7,1.24,3.7,3.71v12.36h4.88v-12.71c0-2.33-.59-3.48-.71-3.69-1.44-2.3-4.76-3.86-8.27-3.87"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m73.02,14.46c0,1.63-1.32,2.94-2.95,2.94s-2.94-1.32-2.94-2.94,1.32-2.94,2.94-2.94,2.95,1.32,2.95,2.94"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m67.63,20.25v18.15h4.88v-18.15c-.75.32-1.57.49-2.44.49s-1.69-.17-2.44-.49"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m115.76,27.96c-.21,1.38-.58,2.57-1.09,3.52-.53.96-1.22,1.68-2.07,2.14-.65.36-1.44.57-2.33.66l-.51.03c-.09,0-.13.01-.26.01-1.14,0-2.07-.27-2.78-.8-.74-.54-1.33-1.3-1.76-2.25-.43-.95-.73-2.07-.89-3.33-.15-1.26-.23-2.62-.23-4.05,0-1.78.11-3.37.32-4.74.22-1.38.59-2.57,1.12-3.53.53-.96,1.25-1.7,2.12-2.21.87-.5,1.85-.73,3.07-.73,1.11,0,2.05.29,2.77.85.74.57,1.33,1.34,1.75,2.29.42.94.72,2.06.88,3.32.16,1.25.24,2.59.24,3.98,0,1.8-.11,3.43-.33,4.84m9.27,8.1c-.56-1.8-2.56-1.77-2.56-1.77h-4.43l.25-.35c.62-.91,1.12-1.87,1.53-2.95.73-1.88,1.09-4.33,1.09-7.29,0-2.32-.17-4.45-.53-6.32-.36-1.85-.95-3.44-1.77-4.71-.82-1.28-1.91-2.28-3.25-2.96-1.35-.69-3.02-1.04-4.99-1.04-3.9,0-6.81,1.22-8.63,3.64-1.82,2.41-2.74,6.16-2.74,11.15,0,2.34.18,4.46.54,6.3.35,1.83.95,3.41,1.76,4.67.82,1.27,1.9,2.27,3.21,2.95,1.33.69,3,1.04,4.96,1.04h.06s.06,0,.09,0c.03,0,.07,0,.11,0h16.01l-.72-2.33Z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m127.44,11.53c.08,0,.17-.04.24-.09.06-.05.1-.16.1-.31,0-.13-.05-.22-.11-.26-.08-.06-.15-.07-.23-.07h-.46v.73h.46Zm.45,1.95l-.63-1.27h-.28v1.27h-.98v-3.39h1.47c.42,0,.75.07.99.25.22.15.33.42.33.79,0,.23-.04.42-.15.58-.1.15-.24.26-.42.36l.73,1.41h-1.05Zm1.92-1.68c0-.75-.22-1.34-.65-1.79-.43-.46-1.03-.69-1.82-.69-.39,0-.73.06-1.03.19-.31.12-.56.29-.78.51-.21.21-.38.49-.5.77-.11.3-.17.64-.17,1.01,0,.74.22,1.33.66,1.79.44.46,1.05.68,1.81.68s1.38-.21,1.82-.68c.44-.46.65-1.05.65-1.79m.79,0c0,.49-.09.94-.24,1.35-.16.39-.39.73-.68.98-.29.27-.64.47-1.03.62-.4.14-.84.21-1.31.21s-.9-.07-1.3-.21c-.4-.15-.75-.36-1.03-.62-.28-.26-.51-.59-.68-.98-.16-.4-.25-.86-.25-1.35s.09-.93.25-1.34c.17-.39.4-.71.68-.99.28-.27.63-.48,1.03-.61.4-.14.83-.21,1.3-.21s.91.07,1.31.21c.39.14.75.34,1.03.61.29.28.52.6.68.99.15.41.24.84.24,1.34"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThinqEn);
export default __webpack_public_path__ + "static/media/thinq-en.b615f0f7b82fc6f2e1213439af45b517.svg";
export { ForwardRef as ReactComponent };